import type { ReactNode } from 'react'

/**
 * The page heading Clerk's UserProfile custom pages show above a settings body.
 * The bodies carry no heading of their own, because the first-party shells
 * (`/settings` and the editor settings modal) supply one. This wrapper puts
 * back the heading the Clerk modal always had. It goes away with the Clerk
 * modal at cutover (LG-1086).
 *
 * The heading is an h2, as the section heading is in `/settings` and the
 * editor settings modal, so the bodies' own h3 subheadings nest correctly in
 * every host (Clerk's navbar carries the modal's top-level "Account" title).
 */
export function ClerkSettingsPage({
  title,
  description,
  children,
}: {
  title: string
  /** A subtitle, which switches to Clerk's built-in Profile/Security header style. */
  description?: string
  children: ReactNode
}) {
  if (description) {
    return (
      <div>
        <div className="mb-4">
          <h2 className="text-foreground text-xl font-bold">{title}</h2>
          <p className="text-muted-foreground mt-0.5 text-sm">{description}</p>
        </div>
        {children}
      </div>
    )
  }
  return (
    <div>
      <h2 className="border-b pb-4 text-xl font-semibold">{title}</h2>
      <div className="mt-4">{children}</div>
    </div>
  )
}
